import React from "react";
import { useSelector } from "react-redux";
import blank from "../assets/blank-avatar.png";
import "./character.css";

const Character = () => {
  const casts = useSelector(state => state.movie.cast);
  return (
    <div className="container">
      <div className="character-wrapper">
        {casts.map(cast => (
          <div className="character" key={cast._id}>
            <div className="cast-image">
              <img
                src={
                  cast.profile_path
                    ? `https://image.tmdb.org/t/p/original/${cast.profile_path}`
                    : blank
                }
              />
            </div>
            <div className="name">
              <p>{cast.name}</p>
            </div>
            <div className="">
              <p>As</p>
            </div>
            <div className="name">
              <p>{cast.character_name}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Character;
